import React, { Component } from 'react'
import Styled from 'styled-components'
import { connect } from 'react-redux'

import { FONT_VARIANT_MAP } from 'shared/enums/index'

import Select from 'editor/Select'

const Container = Styled.div`
  display: flex;
  flex-direction: row;
`

const Family = Styled.div`
  min-width: 0;
  width: 60%;
  padding-right: 0.5rem;
`

const Variant = Styled.div`
  min-width: 0;
  width: 40%;
  padding-left: 0.5rem;
`

class ThemeFont extends Component {
  state = { // eslint-disable-line
    families: [],
    variants: []
  }

  static getDerivedStateFromProps(props) {
    const families = props.fonts.map(font => ({
      value: font.family,
      label: font.family
    }))

    const font = props.fonts.find(_font =>
      _font.family === props.value.family
    )

    const variants = font.variants.map(variant => ({
      value: variant,
      label: FONT_VARIANT_MAP[variant]
    }))

    return {
      families,
      variants
    }
  }

  handleFamilyChange = (family) => {
    const font = this.props.fonts.find(_font =>
      _font.family === family
    )

    const variant = font.variants[0]

    this.props.onChange({ family, variant })
  }

  handleVariantChange = (variant) => {
    const family = this.props.value.family

    this.props.onChange({ family, variant })
  }

  render() {
    return (
      <Container>
        <Family>
          <Select
            options={this.state.families}
            value={this.props.value.family}
            onChange={this.handleFamilyChange}
          />
        </Family>

        <Variant>
          <Select
            options={this.state.variants}
            value={this.props.value.variant}
            onChange={this.handleVariantChange}
          />
        </Variant>
      </Container>
    )
  }
}

const mapDispatchToProps = () => {
  return {}
}

const mapStateToProps = (state) => {
  return {
    fonts: state.project.integrations.google.webfonts
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFont)



// WEBPACK FOOTER //
// ./src/components/ThemeFont/index.js